import { render, staticRenderFns } from "./new-row.vue?vue&type=template&id=94a8cb9e"
import script from "./new-row.vue?vue&type=script&lang=ts"
export * from "./new-row.vue?vue&type=script&lang=ts"
import style0 from "./new-row.vue?vue&type=style&index=0&id=94a8cb9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports